// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import VueCookie from 'vue-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'	

import axios from 'axios'
//import VueAxios from 'vue-axios'
import websocket from '@/components/websocket.vue'
Vue.use(ElementUI);
Vue.use(VueCookie)
Vue.component('websocket', websocket)
Vue.config.productionTip = false

axios.defaults.withCredentials=true;  //跨域保存session有用

//将 axios 赋值给 Vue，方便在子组件里面使用
Vue.prototype.$reqs = axios;

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	//alert("对响应数据做点什么");
  // 对响应数据做点什么
	//alert(response.data.redirectAdmin);
  if(response.data.err){
		alert(response.data.err);
		return Promise.reject(response);
	}else if(response.data.redirectAdmin){
		alert("请先登录后台..");
		window.location.href = "#/admin";
		return Promise.reject(response);
	}else if(response.data.redirectLogin){
		alert("请先登录..");
		window.location.href = "#/login";
		return Promise.reject(response);
	}else{
		//返回response继续执行后面的操作
		return response;
	}
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js